import {capitalizeWords, clean, getAccountInfo, getKeyByValueVal} from "../../utils/GenericUtils";
import {categoriesV2} from "../../utils/dictionaries/Categories";
import moment from "moment";
import {tipiDocumento, tipiDocumentoAnonim} from "../../utils/arrays/Generics";
import {codiciPostaliComuni} from "../../utils/arrays/CodiciPostaliComuni";

const mesiCodice = {
	0: "A",
	1: "B",
	2: "C",
	3: "D",
	4: "E",
	5: "H",
	6: "L",
	7: "M",
	8: "P",
	9: "R",
	10: "S",
	11: "T",
}

export function ticketDefaultValues() {
	return {
		categoria: "",
		cell: "",
		codF: "",
		cognome: "",
		dettaglioRichiesta: "",
		email: "",
		nome: "",
		sottoCategoria: "",
		rispostaOperatore: "",
		comuneNascita: "",
		indirizzoDomicilio: "",
		indirizzoResidenza: "",
		asl: "",
		dst: "",
	}
}

export function getAnaGraficaApi(data) {
	return {
		...clean(data),
		cartaIdentita: data.cartaIdentita ? data.cartaIdentita.toUpperCase() : "",
		patente: data.patente ? data.patente.toUpperCase() : "",
		passaporto: data.passaporto ? data.passaporto.toUpperCase() : "",
		codiceSTP: data.codiceSTP ? data.codiceSTP.toUpperCase() : "",
		codF: data.codF ? data.codF.toUpperCase() : calcCodF(data.nome, data.cognome, data.dataNascita, data.sesso, data.comuneNascita),
		nome: capitalizeWords(data.nome),
		cognome: capitalizeWords(data.cognome),
		tipoDocumento: data.tipoDocumento?.label,
		comuneNascita: getComuneNascita(data),
	}
}

export function getTicketData(data, stato, associati, tags = [], type = "CCM", livello = 0, active = false, src = "CIT") {

	let arrayOfAssociati = [];
	associati.forEach(associato => {
		arrayOfAssociati.push(getAnaGraficaApi(data[associato]));
	})

	let dettaglioRichiesta = "";
	if (data.sendMail) {
		dettaglioRichiesta += "#MOSTRA_USER ";
	}
	if (tags.length > 0) {
		dettaglioRichiesta += tags.join(" ");
	}
	dettaglioRichiesta += " " + data.dettaglioRichiesta;

	console.log(data);

	return {
		...data,
		dettaglioRichiesta: dettaglioRichiesta,
		rispostaOperatore: data.rispostaOperatore ? data.rispostaOperatore : "",
		stato: stato,
		codF: data.codF ? data.codF.toUpperCase() : calcCodF(data.nome, data.cognome, data.dataNascita, data.sesso, data.comuneNascita),
		cartaIdentita: data.cartaIdentita ? data.cartaIdentita.toUpperCase() : data.tipoDocumento === tipiDocumento[0].val ? (data.documento ? data.documento?.toUpperCase() : null) : null,
		patente: data.patente ? data.patente.toUpperCase() : data.tipoDocumento === tipiDocumento[1].val ? data.documento?.toUpperCase() : null,
		passaporto: data.passaporto ? data.passaporto.toUpperCase() : data.tipoDocumento === tipiDocumento[2].val ? data.documento?.toUpperCase() : null,
		codiceSTP: data.codiceSTP ? data.codiceSTP.toUpperCase() : data.tipoDocumento === tipiDocumento[3].val ? data.documento?.toUpperCase() : null,
		documento: data.codF ? data.codF.toUpperCase() :
			data.cartaIdentita ? data.cartaIdentita.toUpperCase() :
				data.patente ? data.patente.toUpperCase() :
					data.codiceSTP ? data.codiceSTP.toUpperCase() :
						data.passaporto ? data.passaporto.toUpperCase() :
							data.documento ? data.documento.toUpperCase() :
								calcCodF(data.nome, data.cognome, data.dataNascita, data.sesso, data.comuneNascita),
		tipoDocumento: data.codF ? "Codice fiscale" : tipiDocumentoAnonim[getKeyByValueVal(tipiDocumentoAnonim, data.tipoDocumento)]?.label,
		nome: capitalizeWords(data.nome),
		cognome: capitalizeWords(data.cognome),
		categoria: data.categoria ? data.categoria : "Informazioni generali",
		sottoCategoria: data.sottoCategoria ? data.sottoCategoria : "Altro",
		src: src,
		dst: data.dst ? data.dst : data.domASL ? "SP_" + data.domASL : "SP_301",
		type: type,
		lastModify: type === "EXT" ? "NULL" : getAccountInfo()?.alias,
		active: active,
		livello: livello,
		rispostaUtente: data.rispostaUtente ? data.rispostaUtente : false,
		associati: arrayOfAssociati,
		comuneNascita: getComuneNascita(data),
	};
}

function getComuneNascita(ticket) {
	if (!ticket.comuneNascita) {
		return "";
	}
	let comuneString = "";
	codiciPostaliComuni.forEach(cod => {
		if (cod.replaceAll(" ", "").includes(ticket.comuneNascita.replaceAll(" ", ""))) {
			comuneString = cod;
		}
	})
	return comuneString;
}

export function getSearchData(data) {
	let result = data;
	if (data.categoria) {
		result = {
			...result,
			categoria: categoriesV2[data.categoria].label,
		}
	}
	if (data.sottoCategoria) {
		result = {
			...result,
			sottoCategoria: data.sottoCategoria?.label,
		}
	}
	return result;
}

function calcCodF(nome, cognome, dataNascita, sesso, codiceComune) {
	if (!nome || !cognome || !dataNascita || !sesso || !codiceComune) {
		return ""
	}
	let calcCodF = "";
	calcCodF += calcCognomeCodF(cognome.replace(/[\W_]+/g, ""));
	calcCodF += calcNomeCodF(nome.replace(/[\W_]+/g, ""));
	calcCodF += calcDataCodF(dataNascita, sesso);
	//1 perché ["Cuneo", "D205"]
	calcCodF += codiceComune.split(",")[1]?.replace(" ", "").replace(" ", "");

	const evenMapPositions = {
		0: 0,
		1: 1,
		2: 2,
		3: 3,
		4: 4,
		5: 5,
		6: 6,
		7: 7,
		8: 8,
		9: 9,
		A: 0,
		B: 1,
		C: 2,
		D: 3,
		E: 4,
		F: 5,
		G: 6,
		H: 7,
		I: 8,
		J: 9,
		K: 10,
		L: 11,
		M: 12,
		N: 13,
		O: 14,
		P: 15,
		Q: 16,
		R: 17,
		S: 18,
		T: 19,
		U: 20,
		V: 21,
		W: 22,
		X: 23,
		Y: 24,
		Z: 25,
	};

	const oddMapPositions = {
		0: 1,
		1: 0,
		2: 5,
		3: 7,
		4: 9,
		5: 13,
		6: 15,
		7: 17,
		8: 19,
		9: 21,
		A: 1,
		B: 0,
		C: 5,
		D: 7,
		E: 9,
		F: 13,
		G: 15,
		H: 17,
		I: 19,
		J: 21,
		K: 2,
		L: 4,
		M: 18,
		N: 20,
		O: 11,
		P: 3,
		Q: 6,
		R: 8,
		S: 12,
		T: 14,
		U: 16,
		V: 10,
		W: 22,
		X: 25,
		Y: 24,
		Z: 23,
	};

	const restMap = {
		0: "A",
		1: "B",
		2: "C",
		3: "D",
		4: "E",
		5: "F",
		6: "G",
		7: "H",
		8: "I",
		9: "J",
		10: "K",
		11: "L",
		12: "M",
		13: "N",
		14: "O",
		15: "P",
		16: "Q",
		17: "R",
		18: "S",
		19: "T",
		20: "U",
		21: "V",
		22: "W",
		23: "X",
		24: "Y",
		25: "Z",
	};

	let startPosition = 1;

	const sum = calcCodF
		.split("")
		.map((char) => {
			const value =
				startPosition % 2 === 0
					? evenMapPositions[char]
					: oddMapPositions[char];
			startPosition++;
			return value;
		})
		.reduce((value, current) => value + current, 0);

	const lastElem = restMap[sum % 26];

	return calcCodF + lastElem;
}

function calcCognomeCodF(str) {
	let [vocali, consonanti] = getConsonantiAndVocali(str.toUpperCase());
	let calcCodF = "";

	for (let i = 0; i < consonanti.length; i++) {
		if (calcCodF.length < 3) {
			calcCodF += consonanti[i].toUpperCase();
		}
	}
	if (calcCodF.length < 3) {
		let length = 3 - calcCodF.length;
		for (let i = 0; i < length; i++) {
			if (vocali[i]) {
				calcCodF += vocali[i].toUpperCase();
			} else {
				calcCodF += "X";
			}
		}
	}

	return calcCodF;
}

function calcNomeCodF(str) {
	let [vocali, consonanti] = getConsonantiAndVocali(str.toUpperCase());
	let calcCodF = "";

	if (consonanti.length >= 4) {
		calcCodF += consonanti[0] + consonanti[2] + consonanti[3]
	} else {
		for (let i = 0; i < consonanti.length; i++) {
			calcCodF += consonanti[i].toUpperCase();
		}
		if (calcCodF.length < 3) {
			let length = 3 - calcCodF.length;
			for (let i = 0; i < length; i++) {
				if (vocali[i]) {
					calcCodF += vocali[i].toUpperCase();
				} else {
					calcCodF += "X";
				}
			}
		}
	}

	return calcCodF;
}

function calcDataCodF(data, sex) {
	let correctData = new Date(data);
	if (correctData === null) {
		return "XXXXX";
	}
	if (correctData && correctData.toString() === "Invalid Date") {
		return "XXXXX";
	}
	let mese = correctData.getMonth();
	let anno = moment(correctData).format("YYYY").substring(2, 4);
	let day = moment(correctData).format("DD");
	let codMese = mesiCodice[mese];
	let s = anno + codMese;
	if (sex && sex !== "Non specificato") {
		if (sex === "Maschio") {
			s += day;
		} else {
			s += (+day + 40);
		}
	} else {
		s += "XX";
	}
	return s;
}

function getConsonantiAndVocali(testo) {
	let consonanti = [];
	let vocali = [];
	for (let i = 0; i < testo.length; i++) {
		if (!isVocale(testo[i].toUpperCase())) {
			consonanti.push(testo[i].toUpperCase());
		} else {
			vocali.push(testo[i].toUpperCase());
		}
	}
	return [vocali, consonanti];
}

function isVocale(lettera) {
	return lettera === "A" || lettera === "E" || lettera === "I" || lettera === "O" || lettera === "U"
}
